import React from 'react';
import { string } from 'prop-types';
import { Frame, Icon, SageTokens } from '@kajabi/sage-react';

type ImgPlaceholderTypes = {
  imgTitle: string;
  size?: string;
  mobile?: boolean;
};

export const CartItemPlaceholderImg = ({ imgTitle, size, mobile }: ImgPlaceholderTypes) => {
  const dimension = size === 'sm' || mobile ? '54px' : '75px';

  return (
    <Frame
      align={Frame.ALIGNMENTS.CENTER_CENTER}
      background={SageTokens.COLOR_SLIDERS.GREY_300}
      borderRadius={Frame.BORDER_RADII.MD}
      width={dimension}
      minWidth={dimension}
      style={{ height: dimension }}
    >
      <Icon
        color={Icon.COLORS.GREY_500}
        icon={Icon.ICONS.IMAGE}
        size={Icon.SIZES.SM}
        className="cart-item__icon"
        label={imgTitle}
      />
    </Frame>
  );
};

CartItemPlaceholderImg.propTypes = {
  imgTitle: string,
  size: string,
};

CartItemPlaceholderImg.defaultProps = {
  imgTitle: '',
  size: '',
};
